import { ContentBlockDto } from '../content-block.dto';

export class ContentBlockImage {
    readonly url: string;
    readonly type = 'image';

    constructor({ data }: ContentBlockDto) {
        this.url = data.file.url;
    }
}
